import Product1 from "../../images/back3.jpg"
import Product2 from "../../images/back2.jpg"
import Product3 from "../../images/back.jpg"
import Food1 from "../../images/back4.jpg"
import Food2 from "../../images/pi.jpg"
import Food3 from "../../images/pizza.jpg"



export const productData = [
    {
        img: Product1,
        alt: 'stake',
        name: 'French Stake',
        desc: 'delicious stake, made in lagos, have fun',
        price: 'N100,000',
        button: 'Add to Cart'
    },
    {
        img: Product2,
        alt: 'fruitshake',
        name: 'Fruit Bomb',
        desc: 'delicious stake, made in lagos, have fun',
        price: 'N200,000',
        button: 'Add to Cart'
    },
    {
        img: Product3,
        alt: 'spag',
        name: 'Italian Spaghetti',
        desc: 'delicious stake, made in lagos, have fun',
        price: 'N250,000',
        button: 'Add to Cart'
    }
]


export const productDataTwo = [
    {
        img: Food1,
        alt: 'Drinks',
        name: 'Drinks On Us',
        desc: 'Enjoy A Good Night Out With Friends',
        price: 'N500,000',
        button: 'Add to Cart'
    },
    {
        img: Food2,
        alt: 'Toast',
        name: 'GeGe Bread',
        desc: 'Start the Day with our GeGe, All On Us',
        price: 'N200,000',
        button: 'Add to Cart'
    },
    {
        img: Food3,
        alt: 'Chinese',
        name: 'Chinese',
        desc: 'Delicious Chinese food, made in lagos, have fun',
        price: 'N250,000',
        button: 'Add to Cart'
    }
]